<template>
	<div class="container">
		<div class="tishi">信息提示：</div>
		<div class="alert">报名成功后，个人信息不能修改，如需修改，请联系考级中心管理员。</div>
		<el-form ref="form" label-width="100px" class="modify-form" :rules="rules" :model="form">
			<el-form-item label="姓名" :error="formError.name">
				<el-input v-model="form.name"></el-input>
			</el-form-item>
			<el-form-item label="姓名全拼" :error="formError.pinyin">
				<el-input v-model="form.pinyin"></el-input>
			</el-form-item>
			<el-form-item label="性别" :error="formError.gender">
				<el-radio-group v-model="form.gender">
					<el-radio :label="0">男</el-radio>
					<el-radio :label="1">女</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="国籍/地区" :error="formError.country_id">
				<el-select v-model="form.country_id">
					<el-option :value="item.id" :label="item.title" v-for="item in guoji" :key="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="民族" :error="formError.nation_id">
				<el-select v-model="form.nation_id">
					<el-option :value="item.id" :label="item.title" v-for="item in minzu" :key="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="身份证号码" :error="formError.id_card">
				<el-input v-model="form.id_card"></el-input>
			</el-form-item>
			<el-form-item label="出生日期" :error="formError.birth">
				<el-date-picker v-model="form.birth" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
			</el-form-item>
			<div style="text-align:center">
				<el-button type="primary" @click="submit" :loading="loading">保存</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { editBase } from "@/api/user";
export default {
	data() {
		return {
			form: { ...this.$store.state.user } || {},
			rules: {},
			formError: {},
			loading: false
		};
	},
	computed: {
		...mapState({ guoji: "guoji", minzu: "minzu" })
	},
	methods: {
		submit() {
			var _this = this;
			let axiosData = {
				name: this.form.name,
				pinyin: this.form.pinyin,
				gender: this.form.gender,
				country_id: this.form.country_id,
				nation_id: this.form.nation_id,
				id_card: this.form.id_card,
				birth: this.form.birth
			};

			this.$refs.form.validate(valid => {
				if (valid) {
					this.loading = true;
					editBase(axiosData)
						.then(res => {
							if (res && res.code === 200) {
								this.$message({
									type: "success",
									message: "修改成功",
									duration: 1000,
									onClose() {
										_this.$router.go(-1);
									}
								});
							} else if (res && res.errors) {
								//表单格式错误
								this.formError = this.$transformError(
									res.errors
								);
							} else {
								this.$message.error(res.message);
							}
						})
						.finally(() => {
							this.loading = false;
						});
				}
			});
		}
	}
};
</script>


<style lang="scss" scoped>
.tishi {
	padding-left: 10px;
	font-size: 18px;
	font-weight: 600;
	margin-top: 20px;
	color: #000;
}
.alert {
	margin-top: 20px;
	padding: 10px 20px;
	background: #eee;
}
.modify-form {
	margin-top: 20px;
}
</style>
